import getIntl from 'Helpers/intl'

export {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ACCOUNT_DATA_RETENTION,
  STORE_KEY_ACCOUNT_OPTIONS,
  STORE_KEY_AUTH,
  STORE_KEY_ID_LIST,
  STORE_KEY_LANG,
  STORE_KEY_LIST,
  STORE_KEY_LISTS_COUNT,
  STORE_KEY_LOGIN_TYPE,
  STORE_KEY_SECURE_OPENER,
  STORE_KEY_USER,
  STORE_KEY_USER_LANG,
  STORE_KEY_USER_LISTS,
  STORE_KEY_USER_OPTIONS
} from 'mailup-react-helpers'

export const DOMAIN_APP_REDIRECTOR = 'automation_app_redirector.aspx?r='

export const LOGIN_TYPE_WEBLOGIN = 0
export const LOGIN_TYPE_ADM = 1
export const LOGIN_TYPE_ADMLIMITED = 2
export const LOGIN_TYPE_RESELLER = 3

export const SOURCES_UPDATE_STATUS_OK = 1
export const SOURCES_UPDATE_STATUS_KO = 2
export const SOURCES_UPDATE_STATUS_NULL = null

export const SKELETON_LOADER_VARIANT_ONWHITE = 'onwhite'
export const SKELETON_LOADER_TYPE_CIRCLE = 'circle'

export const OPT_TASKS_LIST_STATUS_ALL =
  'Load.TriggersList.SearchRecipients.filterAll'
export const OPT_TASKS_LIST_STATUS_ENABLED =
  'Load.TriggersList.StatusSearchEnabled'
export const OPT_TASKS_LIST_STATUS_DISABLED =
  'Load.TriggersList.StatusSearchDisabled'

export const OPT_TASKS_LIST_STATUS_ALL_VALUE = ''
export const OPT_TASKS_LIST_STATUS_ENABLED_VALUE = true
export const OPT_TASKS_LIST_STATUS_DISABLED_VALUE = false

// TasksList STATUS-SELECT
export const OPT_TASKS_LIST_TYPE_ALL =
  'Load.TriggersList.SearchRecipients.filterAll'
export const OPT_TASKS_LIST_TYPE_EMAIL = 'Load.TriggersList.ActionSearchEmail'
export const OPT_TASKS_LIST_TYPE_SMS = 'Load.TriggersList.ActionSearchSms'
export const OPT_TASKS_LIST_TYPE_GROUP = 'Load.TriggersList.ActionSearchGroup'
export const OPT_TASKS_LIST_TYPE_ALL_VALUE = ''
export const OPT_TASKS_LIST_TYPE_EMAIL_VALUE = 'Email'
export const OPT_TASKS_LIST_TYPE_SMS_VALUE = 'SMS'
export const OPT_TASKS_LIST_TYPE_GROUP_VALUE = 'Groups'

export const OPT_TASKS_LIST_TYPE_EMAIL_ID = 0
export const OPT_TASKS_LIST_TYPE_SMS_ID = 1
export const OPT_TASKS_LIST_TYPE_GROUP_ID = -1

export const OPT_TASKS_LIST_FREQUENCY_DAILY = 'd'
export const OPT_TASKS_LIST_FREQUENCY_MONTHLY = 'm'
export const OPT_TASKS_LIST_FREQUENCY_WEEKLY = 'w'
export const OPT_TASKS_LIST_FREQUENCY_YEARLY = 'y'

export const POLLING_MAX_ITERATION = 100
export const POLLING_MAX_INTERVAL = 5000

// Workflows STATUS-SELECT
export const OPT_WORKFLOWS_LIST_STATUS_ALL =
  'Load.AutomationWorkflow.SearchConditionStatusAll'
export const OPT_WORKFLOWS_LIST_STATUS_DRAFT =
  'Load.AutomationWorkflow.SearchConditionStatus1'
export const OPT_WORKFLOWS_LIST_STATUS_ACTIVE =
  'Load.AutomationWorkflow.SearchConditionStatus2'
export const OPT_WORKFLOWS_LIST_STATUS_PAUSED =
  'Load.AutomationWorkflow.SearchConditionStatus3'
export const OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE = 'All'
export const OPT_WORKFLOWS_LIST_STATUS_DRAFT_VALUE = 'Draft'
export const OPT_WORKFLOWS_LIST_STATUS_ACTIVE_VALUE = 'Enabled'
export const OPT_WORKFLOWS_LIST_STATUS_PAUSED_VALUE = 'Disabled'

// Workflows TYPE-SELECT
export const OPT_WORKFLOWS_LIST_TYPE_ALL =
  'Load.AutomationWorkflow.TitleTypeAll'
export const OPT_WORKFLOWS_LIST_TYPE_EVENT =
  'Load.AutomationWorkflow.TitleType1'
export const OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE =
  'Load.AutomationWorkflow.TitleType2'
export const OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION =
  'Load.AutomationWorkflow.TitleType3'
export const OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION =
  'Load.AutomationWorkflow.TitleType4'
export const OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY =
  'Load.AutomationWorkflow.TitleType5'
export const OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN =
  'Load.AutomationWorkflow.TitleType6'
export const OPT_WORKFLOWS_LIST_TYPE_ONBOARDING =
  'Load.AutomationWorkflow.TitleType7'
export const OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY =
  'Load.AutomationWorkflow.TitleType8'
export const OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS =
  'Load.AutomationWorkflow.TitleType9'
export const OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART =
  'Load.AutomationWorkflow.TitleType10'
export const OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES =
  'Load.AutomationWorkflow.TitleType11'

export const OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN =
  'Load.AutomationWorkflow.UnsubscriptionCampaignTitle'

export const OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE = 'All'
export const OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE = 'Event'
export const OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE =
  'SubscriptionDate'
export const OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE = 'SubscriberField'
export const OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE = 'Group'
export const OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE = 'Activity'
export const OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE = 'WelcomeEmail'
export const OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE = 'Onboarding'
export const OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE = 'Birthday'
export const OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE = 'EventReminder'
export const OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE = 'AbandonedChart'
export const OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE = 'WelcomeSeries'
export const OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE =
  'UnsubscriptionCampaign'
//

export const INPUT_MESSAGES_MAX_ITEMS = 100

export const WORKFLOW_START_TYPE_EVENT = 1
export const WORKFLOW_START_TYPE_SUBSCRIPTION_DATE = 2
export const WORKFLOW_START_TYPE_SUBSCRIBER_FIELD = 3
export const WORKFLOW_START_TYPE_GROUP = 4
export const WORKFLOW_START_TYPE_ACTIVITY = 5
export const WORKFLOW_START_TYPE_FILTERS = 6
//

export const WORKFLOW_FIELD_TYPE_INTEGER = 1
export const WORKFLOW_FIELD_TYPE_DECIMAL = 2 //  non usati
export const WORKFLOW_FIELD_TYPE_TEXT = 3
export const WORKFLOW_FIELD_TYPE_DD_MM_YYYY = 5
export const WORKFLOW_FIELD_TYPE_DD_MM = 6
export const WORKFLOW_FIELD_TYPE_MM_DD_YYYY = 7
export const WORKFLOW_FIELD_TYPE_MM_DD = 8
export const WORKFLOW_FIELD_TYPE_YYYYMMDD = 9
export const WORKFLOW_FIELD_TYPE_MMDD = 10
export const WORKFLOW_FIELD_TYPE_YYYY_MM_DD = 11
export const WORKFLOW_FIELD_TYPE_DATETIME = 12

export const WORKFLOW_CONDITION_START_WITH = 1
export const WORKFLOW_CONDITION_END_WITH = 2
export const WORKFLOW_CONDITION_CONTAINS = 3
export const WORKFLOW_CONDITION_NOT_START_WITH = 4
export const WORKFLOW_CONDITION_NOT_END_WITH = 5
export const WORKFLOW_CONDITION_NOT_CONTAIN = 6

export const WORKFLOW_CONDITION_EQUALS = 7
export const WORKFLOW_CONDITION_GREATER_THAN = 8
export const WORKFLOW_CONDITION_GREATER_EQUAL_THAN = 9
export const WORKFLOW_CONDITION_LESSER_THAN = 10
export const WORKFLOW_CONDITION_LESSER_EQUAL_THAN = 11
export const WORKFLOW_CONDITION_NOT_EQUAL = 12

export const WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY = 18
export const WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY = 19
export const WORKFLOW_CONDITION_IS_TODAY = 20
export const WORKFLOW_CONDITION_PLUS_X_DAYS_BEFORE_TODAY = 21
export const WORKFLOW_CONDITION_PLUS_X_DAYS_AFTER_TODAY = 22
export const WORKFLOW_CONDITION_EQUAL_DATE = 23
export const WORKFLOW_CONDITION_BEFORE_DATE = 24
export const WORKFLOW_CONDITION_AFTER_DATE = 25
export const WORKFLOW_CONDITION_MINUS_X_DAYS_BEFORE_TODAY = 26
export const WORKFLOW_CONDITION_MINUS_X_DAYS_AFTER_TODAY = 27

export const WORKFLOW_CONDITION_NOT_NULL_OR_EMPTY = 28
export const WORKFLOW_CONDITION_NULL_OR_EMPTY = 29

export const WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW = 30

export const WORKFLOW_ACTIVITY_ACTION_OPENED = 1
export const WORKFLOW_ACTIVITY_ACTION_NOT_OPENED = 3
export const WORKFLOW_ACTIVITY_ACTION_CLICKED = 2
export const WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED = 4
export const WORKFLOW_ACTIVITY_ACTION_ONE_ACTION = 15
export const WORKFLOW_ACTIVITY_ACTION_TEN_ACTION = 18
export const WORKFLOW_ACTIVITY_ACTION_SMS_SENT = 13
export const WORKFLOW_ACTIVITY_ACTION_SMS_RECEIVED = 23
export const WORKFLOW_ACTIVITY_ACTION_SMS_NOT_DELIVERED = 24
export const WORKFLOW_ACTIVITY_ACTION_SMS_REJECTED = 26
export const WORKFLOW_ACTIVITY_ACTION_SMS_EXPIRED = 25

export const WORKFLOW_ACTIVITY_ACTION_OPTIONS = [
  {
    value: WORKFLOW_ACTIVITY_ACTION_OPENED,
    label: 'Load.AutomationWorkflow.ActivityOpenedLabel'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
    label: 'Load.AutomationWorkflow.ActivityNotOpenedLabel'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_CLICKED,
    label: 'Load.AutomationWorkflow.ActivityClickedLabel'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
    label: 'Load.AutomationWorkflow.ActivityNotClickedLabel'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
    label: 'Load.AutomationWorkflow.ActivityAtLeastOneActionLabel'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_TEN_ACTION,
    label: 'Load.AutomationWorkflow.ActivityTenMoreActionLabel'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_SMS_SENT,
    label: 'Load.AutomationWorkflow.ActivitySendSms'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_SMS_RECEIVED,
    label: 'Load.AutomationWorkflow.ActivitySmsRecived'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_SMS_NOT_DELIVERED,
    label: 'Load.AutomationWorkflow.ActivitySmsNotDelivered'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_SMS_REJECTED,
    label: 'Load.AutomationWorkflow.ActivitySmsNotDeliveredRejected'
  },
  {
    value: WORKFLOW_ACTIVITY_ACTION_SMS_EXPIRED,
    label: 'Load.AutomationWorkflow.ActivitySmsNotDeliveredExpired'
  }
]

export const WORKFLOW_ACTIVITY_ANY_MESSAGE = -10
export const WORKFLOW_ACTIVITY_LAST_5_MESSAGES = -20

export const LBL_ALIAS_STATUS_0_FALSE = 'Load.SMSAlias.StatusPending'
export const LBL_ALIAS_STATUS_0_TRUE = 'Load.SMSAlias.StatusAwaitingApproval'
export const LBL_ALIAS_STATUS_1 = 'Load.SMSAlias.StatusForwardedToAgcom'
export const LBL_ALIAS_STATUS_2 = 'Load.SMSAlias.StatusRemovalInProgress'
export const LBL_ALIAS_STATUS_3 = 'Load.SMSAlias.StatusApproved'
export const LBL_ALIAS_STATUS_4 = 'Load.SMSAlias.StatusNotApproved'
export const LBL_ALIAS_STATUS_5 = 'Load.SMSAlias.StatusNotApprovedToAgcom'

export const LBL_ALIAS_STATUS = [
  {
    key: 0,
    IsTraceableToCompanyName: false,
    value: LBL_ALIAS_STATUS_0_FALSE,
    type: 'info'
  },
  {
    key: 0,
    IsTraceableToCompanyName: true,
    value: LBL_ALIAS_STATUS_0_TRUE,
    type: 'warning'
  },
  { key: 1, value: LBL_ALIAS_STATUS_1, type: 'warning' },
  { key: 2, value: LBL_ALIAS_STATUS_2, type: 'default' },
  { key: 3, value: LBL_ALIAS_STATUS_3, type: 'success' },
  { key: 4, value: LBL_ALIAS_STATUS_4, type: 'error' },
  { key: 5, value: LBL_ALIAS_STATUS_5, type: 'error' }
]

export const MESSAGE_TYPE_GENERIC = 0
export const MESSAGE_TYPE_WELCOME = 1
export const MESSAGE_TYPE_CONFIRMATION = 2
export const MESSAGE_TYPE_CONTENTSCAMPAIGN = 3

export const MESSAGE_STR_TYPE_GENERIC = 'Generic'
export const MESSAGE_STR_TYPE_WELCOME = 'Welcome'
export const MESSAGE_STR_TYPE_CONFIRMATION = 'Confirmation'
export const MESSAGE_STR_TYPE_CONTENTSCAMPAIGN = 'ContentsCampaign'

export const SERVICE_TYPE_CONSOLE = 0
export const SERVICE_TYPE_SMTPPLUS = 1
export const SERVICE_TYPE_FASTEMAIL = 2
export const SERVICE_TYPE_ONETOMANY = 3
export const SERVICE_TYPE_WSIMPORTCONFIRMATI = 4

export const WORKFLOW_STEP_VALUE_TYPE_DAYS = 0
export const WORKFLOW_STEP_VALUE_TYPE_HOURS = 1

export const WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT = 0
export const WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_OPENED = 1
export const WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_CLICKED = 2
export const WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_NOT_OPENED = 3
export const WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_NOT_CLICKED = 4
export const WORKFLOW_STEP_WAIT_TYPE_AFTER_SMS_SENT = 5
export const WORKFLOW_STEP_WAIT_TYPE_AFTER_SMS_DELIVERED = 6
export const WORKFLOW_STEP_WAIT_TYPE_SMS_NOT_DELIVERED = 8
export const WORKFLOW_STEP_WAIT_TYPE_SMS_EXPIRED = 9
export const WORKFLOW_STEP_WAIT_TYPE_SMS_REJECTED = 10

export const WORKFLOW_EMAIL_WAIT_OPTIONS = [
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterSent'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_OPENED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterOpen'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_CLICKED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterClicked'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_NOT_OPENED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterNotOpen'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_NOT_CLICKED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterNotClicked'
  }
]

export const WORKFLOW_SMS_WAIT_OPTIONS = [
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_SMS_SENT,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterSendSms'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_AFTER_SMS_DELIVERED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterOpenSms'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_SMS_NOT_DELIVERED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterNotOpenSms'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_SMS_EXPIRED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfterNotOpenSmsExpired'
  },
  {
    value: WORKFLOW_STEP_WAIT_TYPE_SMS_REJECTED,
    label: 'Load.AutomationWorkflow.DragElementWaitAfternotOpenSmsRejected'
  }
]

export const WORKFLOW_WAIT_ERROR_REQUIRED_VALUE = 'requiredValue'
export const WORKFLOW_WAIT_ERROR_REQUIRED_WAIT = 'requiredWait'
export const WORKFLOW_WAIT_ERROR_WRONG_FORMAT = 'wrongFormat'
export const WORKFLOW_WAIT_ERROR_MAX_DAYS = 'maxDays'
export const WORKFLOW_WAIT_ERROR_POSITION = 'position'

export const WORKFLOW_WAIT_ERROR_REQUIRED_LABEL =
  'Load.AutomationWorkflow.ValidationRequired'
export const WORKFLOW_WAIT_ERROR_WRONG_FORMAT_LABEL =
  'Load.AutomationWorkflow.ValidationWrongFormat'
export const WORKFLOW_WAIT_ERROR_MAX_DAYS_LABEL =
  'Load.AutomationWorkflow.ValidationMaxDays'
export const WORKFLOW_WAIT_ERROR_POSITION_LABEL =
  'Load.AutomationWorkflow.ValidationChangeCondition'

export const MATCH_FILTER_CONDITION_ALL = 'All'
export const MATCH_FILTER_CONDITION_AT_LEAST_ONE = 'AtLeastOne'

export const FILTER_TYPE_ANAGRAPHIC = 'Anagraphic'
export const FILTER_TYPE_ACTIVITY = 'Activity'
export const FILTER_TYPE_DEVICE = 'Device'
export const FILTER_TYPE_GEOLOCATION = 'Geolocation'
export const FILTER_TYPE_MULTIFILTER = 'MultiFilter'
export const FILTER_TYPE_MULTITYPE = 'MultiType'
export const FILTER_TYPE_ENGAGEMENT = 'Engagement'

export const DATA_RETENTION_LIMIT_YEAR = 360
export const DATA_RETENTION_LIMIT_THREE_MONTHS = 90

export const WORKFLOW_WAIT_TYPE_MODE_EMAIL = 'email'
export const WORKFLOW_WAIT_TYPE_MODE_SMS = 'sms'

export const INPUT_GROUPS_MAX_ITEMS = 700

export const CAMPAIGN_CHANNEL_EMAIL = 1
export const CAMPAIGN_CHANNEL_MESSENGER = 2
export const CAMPAIGN_CHANNEL_TELEGRAM = 3

export const CONTENT_SOURCE_UPDATE_STATUS_OK = 1
export const CONTENT_SOURCE_UPDATE_STATUS_KO = 2

export const MESSAGE_AUTOSAVE_TIMEOUT = 30
export const GOOGLE_FAQ_URL = 'https://developers.google.com/fonts/faq'
export const GOOGLE_PRIVACY_URL = 'https://www.google.com/policies/privacy'

// async search
export const SELECT_MAX_ITEMS = 100
export const GROUPS_SEARCH_TYPE_EQUALTO = 'EQUALTO'
export const GROUPS_SEARCH_TYPE_ECONTAINS = 'CONTAINS'

// campaign wizard -- step 4
export const arrDaysOfWeek = [
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Sunday' }),
    value: 0
  },
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Monday' }),
    value: 1
  },
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Tuesday' }),
    value: 2
  },
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Wednesday' }),
    value: 3
  },
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Thursday' }),
    value: 4
  },
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Friday' }),
    value: 5
  },
  {
    name: getIntl().formatMessage({ id: 'Load.MailupCommon.Saturday' }),
    value: 6
  }
]

export const MAX_SAVED_ROW_NUMBER = 30
export const SOURCE_ID_TYPE_URL = 1
export const SOURCE_ID_TYPE_FILE = 2

export const NEW_EDIT_SOURCE_MAX_UPLOAD_SIZE = 5 * 1024 * 1024
export const EXPIRE_IN = 5

export const getExtension = (fileOrUrl) => {
  return fileOrUrl.split('?')[0].split('.').pop()
}

export const NEW_EDIT_SOURCE_FILE_ACCEPT = ['.csv', '.json', '.zip']

export const SOURCES_MAX_CONTENTS = 5000

export const MIME_TYPE_CSV = 'text/csv'
export const MIME_TYPE_JSON = 'application/json'

export const DATE_PICKER_FORMAT = 'yyyy-MM-dd'

export const APP_CLIENT_ID = '6dd5790f-2e26-496d-a06e-aec50bd4b4cf'
